export default __webpack_public_path__ + "cd3794bfdec6e90a7744e01536b83cbc.png";